<template>
  <Modal :hide-close="true">
    <Modal.Body>
      <UpdatedTermsBody />
    </Modal.Body>
    <Modal.Footer class="mt-[18px]!">
      <Button variant="primary" size="md" @click="handleGotIt">Got it</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { useAcceptTermsMutation } from '@/shared/graphql/legacy/generated'
import UpdatedTermsBody from './UpdatedTermsBody.vue'

const { close, triggerEvent } = useModal()

const { mutate: acceptTerms } = useAcceptTermsMutation()

const handleGotIt = () => {
  acceptTerms()
  triggerEvent('success')
  close()
}
</script>
